import CoacheeOnboardingAnswers from '@efdigital/ll-xceed-v2/components/coaching/coach/coachee-onboarding-answers.gts';
import type { CoachingCoachCoacheesCoacheeAboutModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee/about';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachCoacheesCoacheeAboutSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeAboutModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "About"}}

  <CoacheeOnboardingAnswers @onboardingAnswers={{@model.onboardingAnswers}} />
</template> satisfies TOC<CoachingCoachCoacheesCoacheeAboutSignature>;
